import { addToast } from '@mobi/component-library/Feedback/Toast'
import type { BetAccountHolder, PostFeedbackDataToApiPayload } from '@mobi/api-types'
import { postFeedbackDataToApi } from './api'

export const handleFormSubmission = async ({
  message,
  subject,
  setMessage,
  setIsBusy,
  accountNumber,
  contactDetails,
}: {
  message: string
  subject: string
  setMessage: React.Dispatch<React.SetStateAction<string>>
  setIsBusy: React.Dispatch<React.SetStateAction<boolean>>
  accountNumber: number
  contactDetails?: BetAccountHolder
}) => {
  try {
    setIsBusy(true)
    if (!contactDetails) throw Error()

    await postFeedbackDataToApi(
      mapFormValuesToApiData({ message, subject, accountNumber, contactDetails })
    )

    setMessage('')
    setIsBusy(false)
    addToast({
      id: 'feedback-sent',
      icon: 'success',
      title: 'Feedback Sent',
    })
  } catch {
    setIsBusy(false)
    addToast({
      id: 'feedback-failed',
      icon: 'error',
      title: 'Sorry, Unable to Send',
    })
  }
}

// =============
// Local Helpers
// =============

function mapFormValuesToApiData({
  message,
  subject,
  accountNumber,
  contactDetails,
}: {
  message: string
  subject: string
  accountNumber: number
  contactDetails: BetAccountHolder
}): PostFeedbackDataToApiPayload {
  if (!contactDetails) throw Error()

  return {
    Account: accountNumber.toString(),
    Email: contactDetails.Contact?.Email,
    FirstName: contactDetails.NameDetails.FirstName,
    Message: message,
    Phone: contactDetails.Contact?.Mobile?.PhoneNumber,
    Subject: subject,
    Surname: contactDetails.NameDetails.Surname,
    ScreenHeight: 0,
    ScreenWidth: 0,
    PixelDepth: 0,
  }
}
